import { useRef, type CSSProperties, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { spaceHomeSubPageShellCssVars } from "../../space/home/Config";
import { PAGE_SHELL_BG } from "../../utils/pageShellBg";
import { useDocumentSpaceTheme } from "../../utils/useDocumentSpaceTheme";
import { h5NavigateTo } from "../../utils/miniProgramEnv";
import { usePageShellBg } from "../../utils/usePageShellBg";
import { useSafeAreaTopPad } from "../../utils/useSafeAreaTopPad";
import { H5BackButton } from "./H5BackButton";
import { h5BackButtonCssVars } from "./H5BackButtonConfig";
import "./H5SubPageShell.css";

type Props = {
  title: string;
  backTo?: string;
  onBack?: () => void;
  headerRight?: ReactNode;
  children: ReactNode;
};

/** 空间内二级页通用壳：顶栏返回 + 标题 + 可滚动内容区 */
export function H5SubPageShell(props: Props) {
  const { title, backTo, onBack: onBackProp, headerRight, children } = props;
  const navigate = useNavigate();
  const headerRef = useRef<HTMLElement>(null);
  const safeTopPad = useSafeAreaTopPad(headerRef);

  useDocumentSpaceTheme(true);

  usePageShellBg({
    bg: PAGE_SHELL_BG.spaceLight,
    front: "#000000",
    title,
  });

  const onBack = () => {
    if (onBackProp) {
      onBackProp();
      return;
    }
    if (backTo) {
      h5NavigateTo(navigate, backTo);
      return;
    }
    navigate(-1);
  };

  const headerStyle: CSSProperties | undefined =
    safeTopPad > 0
      ? ({ "--h5-sub-page-header-safe-top-pad": `${safeTopPad}px` } as CSSProperties)
      : undefined;

  return (
    <div className="h5-sub-page" style={{ ...h5BackButtonCssVars(), ...spaceHomeSubPageShellCssVars() }}>
      <header ref={headerRef} className="h5-sub-page__header" style={headerStyle}>
        <div className="h5-sub-page__header-side h5-sub-page__header-side--left">
          <H5BackButton
            className="h5-sub-page__back"
            iconClassName="h5-back-button__icon h5-back-button__icon--invert"
            onClick={onBack}
          />
        </div>
        <h1 className="h5-sub-page__title">{title}</h1>
        <div className="h5-sub-page__header-side h5-sub-page__header-side--right">
          {headerRight ?? <span className="h5-sub-page__header-spacer" aria-hidden />}
        </div>
      </header>
      <div className="h5-sub-page__body">{children}</div>
    </div>
  );
}
